import { Link } from 'react-router-dom';
import { categories } from '../data/categories';
import { getProductsByCategory } from '../data/products';
import { useReveal } from '../hooks/useReveal';
import PageHero from '../components/PageHero';
import CategoryCard from '../components/CategoryCard';
import CTASection from '../components/CTASection';
import Icon from '../components/Icon';
import machiningOil from '../assets/images/machining-oil.jpg';

export default function Products() {
  useReveal('products');

  return (
    <div>
      <PageHero
        eyebrow="Our Portfolio"
        title="Specialty petrochemical products, engineered to perform"
        description="Explore four families of petroleum-based additives and dyes — each backed by consistent quality, ASTM-tested specifications and reliable supply."
        image={machiningOil}
      />

      <section className="container-page py-16 sm:py-20">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c, i) => (
            <div key={c.slug} className="reveal" style={{ transitionDelay: `${i * 80}ms` }}>
              <CategoryCard category={c} />
            </div>
          ))}
        </div>
      </section>

      {/* Deep dive per family */}
      <section className="bg-surface py-16 sm:py-20">
        <div className="container-page space-y-16">
          {categories.map((c) => {
            const items = getProductsByCategory(c.slug);
            const isDyes = c.slug === 'fuel-petroleum-dyes';
            return (
              <div key={c.slug} className="reveal grid gap-8 lg:grid-cols-[1fr_1.4fr] lg:items-start">
                <div>
                  <p className="eyebrow">{c.name}</p>
                  <h2 className="mt-3 text-2xl font-bold text-text-primary">{c.tagline}</h2>
                  <p className="mt-4 leading-7 text-text-secondary">{c.intro}</p>
                  <Link to={`/products/${c.slug}`} className="btn-primary mt-6">
                    Explore {c.name} <Icon name="arrow" className="h-4 w-4" />
                  </Link>
                </div>
                <div className="grid gap-3 sm:grid-cols-2">
                  {items.slice(0, 6).map((p) => (
                    <Link
                      key={p.id}
                      to={`/products/${c.slug}/${p.id}`}
                      className="group flex items-center gap-3 rounded-xl bg-background p-4 ring-1 ring-ink/5 transition-colors hover:bg-muted"
                    >
                      <span className="rounded-md bg-primary/8 px-2 py-1 font-mono text-[0.7rem] font-semibold text-primary">
                        {p.code}
                      </span>
                      <span className="line-clamp-1 text-sm font-medium text-text-primary">{p.name}</span>
                      <Icon
                        name="arrow"
                        className="ml-auto h-4 w-4 flex-none text-primary opacity-0 transition-all group-hover:translate-x-1 group-hover:opacity-100"
                      />
                    </Link>
                  ))}
                  {items.length > 6 && (
                    <Link
                      to={`/products/${c.slug}`}
                      className="flex items-center justify-center rounded-xl border border-dashed border-primary/30 p-4 text-sm font-semibold text-primary hover:bg-primary/5"
                    >
                      +{items.length - 6} more products
                    </Link>
                  )}
                  {isDyes && (
                    <Link
                      to={`/products/${c.slug}`}
                      className="flex items-center justify-center rounded-xl border border-dashed border-primary/30 p-4 text-sm font-semibold text-primary hover:bg-primary/5"
                    >
                      View 15-dye colour range
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
